import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 100%)',
  padding: {
    xs: '2.4rem ',
    md: '4rem 5.6rem',
    lg: '8rem 0',
  },
}

export const contentSx: SxProps<Theme> = {
  margin: 'auto',
  maxWidth: {
    xs: '100%',
    lg: '117.6rem',
    xl: '151.6rem',
  },
  rowGap: {
    xs: '2.4rem',
    lg: '8rem',
  },
  columnGap: {
    md: '2.4rem',
    lg: '4.8rem',
  },
}

export const itemSx = {
  xs: 'span 12',
  md: 'span 6',
}
